module.exports = __webpack_public_path__ + "static/img/mp4.ff4537ad.png";